
import { useContext } from "react";
import { Link } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import { textes } from "../../constants/textes";


export default function Transaction({transaction, position}) {
    // states
    const {user} = useContext(UserContext);


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td style={{minWidth: "296px"}}>
                <div className="d-flex flex-row">
                    <div className="widget-content-left mr-3">
                        <img style={{width: 48, height: 48}} className="rounded" src={"/assets/imgs/blank.png"} alt="" />
                    </div>
                    <div className="widget-content-left">
                        <div className="widget-heading">{transaction?.nom}</div>
                        <div className="widget-subheading">{transaction?.numtel}</div>
                    </div>
                </div>
            </td>
            {transaction?.codeforfait !== null && <td>
                <div className="d-flex flex-row">
                    <div className="widget-content-left mr-3">
                        <img style={{width: 48, height: 48}} className="rounded" src={transaction.imgforfait !== null ? transaction?.imgforfait : "/assets/imgs/no-image.png"} alt="" />
                    </div>
                    <div className="widget-content-left">
                        <div className="widget-heading">{transaction?.lib}</div>
                        <div className="widget-subheading">{transaction?.profileforfait}</div>
                    </div>
                </div>
            </td>}
            {transaction?.codeabonnement !== null && <td>
                <div className="d-flex flex-row">
                    <div className="widget-content-left mr-3">
                        <img style={{width: 48, height: 48}} className="rounded" src={transaction.imgabonnement !== null ? transaction?.imgabonnement : "/assets/imgs/no-image.png"} alt="" />
                    </div>
                    <div className="widget-content-left">
                        <div className="widget-heading">{transaction?.libabonnement}</div>
                        <div className="widget-subheading">{transaction?.pack}</div>
                    </div>
                </div>
            </td>}
            <td>{transaction.operateur !== null ? transaction?.operateur : ""}</td>
            <td>{transaction.montant !== null ? transaction?.montant + " XAF" : ""}</td>
            {transaction?.codeforfait !== null && <td>{transaction.montantinternerecu !== null ? transaction?.montantinternerecu + " XAF" : ""}</td>}
            {transaction?.codeabonnement !== null && <td>{transaction.montantpercu !== null ? Number.parseInt(transaction?.montantpercu) + " XAF" : ""}</td>}
            <td>
                <span 
                    className={`badge ${
                        transaction.etat === 1 ? "badge-info" : 
                        transaction.etat === 2 ? "badge-warning" : 
                        transaction.etat === 3 ? "badge-danger" : 
                        transaction.etat === 4 ? "badge-success" : 
                        ""
                        } mt-2`
                    } 
                    style={{fontSize: 14}}>
                        {
                            transaction.etatdef !== null ? transaction?.etatdef : 
                            "Etat"
                        }
                </span>
            </td>
            <td>{transaction?.datecrea.slice(0, 16).replace("T", " à ")}</td>
            <td className="text-center">
                {(user?.isFullAction || user?.isAdminAction || user?.isConsulterTransaction) && 
                    <Link to={`/transaction/${transaction?.code}`} data-toggle="tooltip" title={textes.fr.viewtransactionlabel} data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                        <i className="fa fa-eye"></i>
                    </Link>
                }
            </td>
        </tr>
    )
}